// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__e1qY-","sliderRound":"styles_sliderRound__E4+Ta","checkbox":"styles_checkbox__y2gzW","checkIcon":"styles_checkIcon__-OubU"};